export default "__VITE_ASSET__DoULzlII__"